import md from '@/routes/middlewares';

import WorkOrderView from '@/views/workOrders/WorkOrderView.vue';

const workOrder = {
    path: 'workOrders/:workOrderId',
    component: WorkOrderView,
    name: 'WorkOrderView',
    meta: {
        middlewares: [
            md.getWorkOrderInfo,
        ],
    },
};
export default workOrder;
